export const common = {
    languages: {
        pt_br: "pt-br",
        en_us: "en-us",
    },
    labels: {
        account: "Conta",
        accounts: "Contas",
        active: "Ativo",
        action: "Ação",
        actions: "Ações",
        address: "Endereço",
        addresses: "Endereços",
        add: "Adicionar {concat}",
        administrator: "Administrador",
        alert: "Alerta",
        analyse: "Análise",
        analysis: "Análises",
        apply: "Aplicar",
        arcade: "Arcade",
        arcades: "Arcades",
        assistant: "Auxiliar",
        assistants: "Auxiliares",
        avatar: "Avatar",
        back: "Voltar",
        bigger: "Maior",
        birthdate: "Nascimento",
        blog: "Blog",
        brand: "Marca",
        calc: "Cálculo",
        calibration_date: "Data de Calibração",
        category: "Categoria",
        categories: "Categorias",
        cancel: "Cancelar {concat}",
        canceled: "Cancelado",
        canceleds: "Cancelados",
        cep: "CEP",
        certificate: "Certificado",
        certificates: "Certificados",
        change_account: "Trocar Conta",
        chart: "Gráfico",
        charts: "Gráficos",
        city: "Cidade",
        city_of_origin: "Cidade de Origem",
        clean: "Limpar",
        close: "Fechar",
        closing_date: "Data de Encerramento",
        cnae: "CNAE",
        cnpj: "cnpj",
        cockpit: "Cockpit",
        code: "Código",
        collection: "Coleção",
        collections: "Coleções",
        company: "Empresa",
        companies: "Empresas",
        complement: "Complemento",
        condition: "Condição",
        conditions: "Condições",
        concluded: "Concluído",
        confirm: "Confirmar",
        confirm_password: "Confirmar senha",
        configs: "Configurações",
        console: "Console",
        consoles: "Consoles",
        continue: "Continuar",
        contact: "Contato",
        contacts: "Contatos",
        corporate_reason: "Razão Social",
        country: "País",
        country_of_origin: "País de Origem",
        currency: "Moeda",
        cpf: "cpf",
        created: "Cadastrado",
        crew: "Equipe",
        cv: "Curriculum",
        deduct: "Subtrair",
        date: "Data",
        dates: "Datas",
        days: "Dias",
        day: "Dia",
        delete: "Excluir {concat}",
        description: "Descrição",
        details: "Detalhes",
        district: "Bairro",
        divide: "Dividir",
        document: "Documento",
        documents: "Documentos",
        document_type: "Tipo de documento",
        download: "Download",
        edit: "Editar {concat}",
        equal: "Igual",
        equipment: "Equipamento",
        equipments: "Equipamentos",
        email: "E-mail",
        employee: "Funcionário",
        employees: "Funcionários",
        enter: "Entrar",
        exit: "Sair",
        expiration: "Vencimento",
        expiration_date: "Data de Validade",
        evaluation: "Avaliação",
        evaluations: "Avaliações",
        fabrication: "Data de Fabricação",
        fantasy_name: "Nome Fantasia",
        field: "Campo",
        fields: "Campos",
        file: "Arquivo",
        files: "Arquivos",
        finish: "Finalizar",
        finances: "Finanças",
        form: "Formulário",
        forms: "Formulários",
        foundation_date: "Data de Fundação",
        fusion_date: "Data de Fusão",
        footer: "Rodapé",
        free: "Grátis",
        group: "Grupo",
        groups: "Grupos",
        home: "Home",
        if: "Se",
        inactive: "Inativo",
        invoices: "Faturas",
        info: "Informação",
        infos: "Informações",
        item: "Item",
        items: "Itens",
        laboratory: "Laboratório",
        laboratories: "Laboratórios",
        language: "Idioma",
        languages: "Idiomas",
        login: "Login",
        manager: "Gestor",
        manufacturer: "Fabricante",
        manufacturers: "Fabricantes",
        member: "Membro",
        members: "Membros",
        menu: "Menu",
        method: "Método",
        methods: "Métodos",
        method_group: "Grupo de Métodos",
        microcomputer: "Microcomputador",
        microcomputers: "Microcomputadores",
        model: "Modelo",
        my_agenda: "Minha Agenda",
        my_account: "Minha Conta",
        my_profile: "Meu Perfil",
        name: "Nome",
        new: "Novo {concat}",
        new_password: "Nova senha",
        next: "Próximo",
        next_calibration: "Próxima Calibração",
        number: "Número",
        number_of_employee: "Número de funcionários",
        not: "Não",
        observation: "Observação",
        observations: "Observações",
        open: "Abrir",
        option: "Opção",
        options: "Opções",
        order: "Ordem",
        other: "Outro",
        other_names: "Outros Nomes",
        page: "Página",
        pages: "Páginas",
        per_page: "Itens por página",
        password: "Senha",
        pending: "Pendente",
        phone: "Telefone",
        plans: "Planos",
        play: "Iniciar {concat}",
        platform: "Plataforma",
        platforms: "Plataformas",
        position: "Posição",
        positions: "Posições",
        price: "Valor",
        print: "Imprimir",
        progress: "Progresso",
        qualification: "Qualificação",
        qualifications: "Qualificações",
        question: "Pergunta",
        questions: "Perguntas",
        refresh: "Atualizar",
        registration: "Cadastro",
        registrations: "Cadastros",
        register: "Cadastrar",
        required: "Obrigatório",
        remove: "Remover {concat}",
        report: "Relatório",
        reports: "Relatórios",
        role: "Cargo",
        sale_date: "Data de Venda",
        sample: "Amostra",
        samples: "Amostras",
        save: "Salvar",
        search: "Buscar",
        search_exact: "Busca exata",
        sector: "Setor",
        send: "Enviar",
        serial_number: "Número de Série",
        service: "Serviço",
        services: "Serviços",
        setting: "Configuração",
        settings: "Configurações",
        showing: "Mostrando",
        signature: "Assinatura",
        sign: "Assinar",
        slug: "Slug",
        skill: "Skill",
        skills: "Skills",
        smaller: "Menor",
        social_name: "Nome Social",
        start: "Início",
        started: "Iniciado",
        state: "Estado",
        status: "Status",
        stop: "Parar",
        subscriptions: "Assinaturas",
        subtitle: "Subtítulo",
        sum: "Somar",
        summary: "Sumário",
        technical: "Técnico",
        technicals: "Técnicos",
        termination: "Término",
        term: "Termo",
        terms: "Termos",
        title: "Título",
        titles: "Títulos",
        time: "Tempo",
        total_duration: "Duração total",
        type: "Tipo",
        upload: "Upload {concat}",
        updated: "Atualizado",
        user: "Usuário",
        users: "Usuários",
        validity: "Validade",
        visible: "Visível",
        vacancy: "Vaga",
        vacancies: "Vagas",
        value: "Valor",
        yacht: "Iate",
        yachts: "Iates",
        yes: "Sim",
        web_site: "Site",
    },
    placeholders: {
        city_of_origin: "Informe a cidade de origem",
        code: "Informe o código",
        country_of_origin: "Informe o país de origem",
        date_example: "Exe: 15/03/1889",
        describe: "Descreva",
        email: "Informe o e-mail",
        login: "Informe seu Login",
        name: "Informe o nome",
        order: "Informe a órdem",
        sector: "Informe o setor",
        password: "Informe sua Senha",
        select: "Selecione...",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_name: "Adicionar Nome",
            remove_avatar: "Remover Avatar",
            remove_name: "Remover Nome",
        },
        messages: {
            add_name: "Você deseja adicionar um <strong>NOME</strong>?",
            remove_avatar: "Você deseja remover o <strong>AVATAR</strong>?<br/>Esta ação não poderá ser desfeita!",
            remove_name: "Você deseja remover o <strong>NOME</strong>?<br/>Esta ação não poderá ser desfeita!",
        },
    },
    texts: {
        no_results: "Não há resultados para serem exibidos.",
        forgot_password: "Esqueceu sua Senha?",
        recover_password: "Recuperar Senha",
        already_account: "Já possui conta?",
        dont_account: "Não possui conta?",
        register_account: "Registrar conta",
        remembered_password: "Lembrou sua senha?",
        undo_message: "Essa operação não poderá ser desfeita!",
        item_message: "Os itens adicionados também serão perdidos!",
        remove_message: "Você deseja remover <strong>''{concat}''</strong>?<br/>Esta ação não poderá ser desfeita!",
        input_code: "Digite abaixo o código que foi enviado para o e-mail cadastrado:",
        file_upload: "Selecione ou arraste o arquivo para enviar",
        model_download: "Baixar arquivo o modelo",
        not_deletable: "Não é possível remover o item selecionado!",
        search_multiple: "Selecione um ou mais items",
        empty_name: "Não há nomes para exibir.",
        add_name: "Adicionar nome",
        delete_name: "Excluir nome",

    }
};